import { i18n } from '@/helpers/i18n';

/**
 * Keys must match {@link numberFormats} entries in i18n.js.
 */
export const NUMBER_FORMAT = {
  CURRENCY: 'currency',
  CURRENCY_ROUNDED: 'currency_rounded',
  PERCENT: 'percent',
  PERCENT_FIVE_DECIMALS: 'percent_five_decimals',
  DECIMAL_ZERO: 'decimal_zero',
  DECIMAL_SINGLE: 'decimal_single',
  DECIMAL: 'decimal',
  DECIMAL_TRIPLE: 'decimal_triple',
  DECIMAL_QUADRUPLE: 'decimal_quadruple',
  DECIMAL_QUINQUIPLE: 'decimal_quinquiple',
};

const DEFAULT_FALLBACK = '\u2013';

/**
 * @param {*} rawValue
 * @returns {number|null}
 */
export const parseFiniteNumber = (rawValue) => {
  if (rawValue === null || rawValue === undefined || rawValue === '') {
    return null;
  }
  const numericValue = typeof rawValue === 'number' ? rawValue : Number(rawValue);
  if (!Number.isFinite(numericValue)) {
    return null;
  }
  return numericValue;
};

/**
 * Validates and formats a numeric value with vue-i18n number formats.
 *
 * @param {*} value
 * @param {string} format - One of {@link NUMBER_FORMAT}
 * @param {string} [fallback='\u2013']
 * @returns {string}
 */
export const formatNumber = (value, format, fallback = DEFAULT_FALLBACK) => {
  const numericValue = parseFiniteNumber(value);
  if (numericValue === null) {
    return fallback;
  }
  return i18n.n(numericValue, format);
};

/**
 * Formats a numeric value with a separate unit suffix (label/placeholder convention).
 *
 * @param {*} value
 * @param {string} format - One of {@link NUMBER_FORMAT} (decimal-style formats only)
 * @param {string} unitKey - i18n key for the unit (e.g. `unit_eur`)
 * @param {string} [fallback='\u2013']
 * @returns {string}
 */
export const formatNumberWithUnit = (value, format, unitKey, fallback = DEFAULT_FALLBACK) => {
  const unit = i18n.t(unitKey);
  const numericValue = parseFiniteNumber(value);
  if (numericValue === null) {
    return `${fallback} ${unit}`;
  }
  return `${formatNumber(numericValue, format)} ${unit}`;
};
